import styled from "styled-components"

export const Wrapper = styled.div`
width: 100%;
height: 100vh;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
box-sizing: border-box;

@media (max-width: 768px) {
  width: 100%;
  padding: 15px;
}
`

export const IconWrap = styled.div`
  color: #fff;
  margin-bottom: 24px;
`

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  font-family: "Inter", Arial, sans-serif;
  color: #fff;
  margin: 0 0 16px;
`

export const Description = styled.p`
  font-size: 16px;
  font-family: "Inter", Arial, sans-serif;
  color:rgb(182, 180, 180);
  margin: 0;
  line-height: 1.5;
  text-align: center;
`
